import styled from "styled-components"

export const ButtonsWrapper = styled.footer`
  display: flex;
  flex-direction: column;
  padding: 0 1px 1px;
`

export default ButtonsWrapper
